import { render, staticRenderFns } from "./ThgCheckoutOrderCard.vue?vue&type=template&id=4fe638a3"
import script from "./ThgCheckoutOrderCard.vue?vue&type=script&lang=ts"
export * from "./ThgCheckoutOrderCard.vue?vue&type=script&lang=ts"
import style0 from "./ThgCheckoutOrderCard.vue?vue&type=style&index=0&id=4fe638a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports